const API_BASE = "http://127.0.0.1:8000/api";

async function parseJson(response) {
  const text = await response.text();
  try {
    return text ? JSON.parse(text) : [];
  } catch {
    return [];
  }
}

export async function fetchLatestTelemetry() {
  const response = await fetch(`${API_BASE}/telemetry/latest/`);

  if (!response.ok) {
    throw new Error(`Failed to fetch latest telemetry: ${response.status}`);
  }

  return parseJson(response);
}

export async function fetchAllTelemetry() {
  const response = await fetch(`${API_BASE}/telemetry/`);

  if (!response.ok) {
    throw new Error(`Failed to fetch telemetry: ${response.status}`);
  }

  return parseJson(response);
}